import { BorderStyle, Box, Color } from '@gousto-internal/citrus-react'
import type { DashboardExperienceOrderDeliveryDetailsResponse } from '@library/api-dashboard-experience'
import React, { type CSSProperties } from 'react'
import { ManageDeliveryPanelContent } from '../ManageDeliveryPanelContent'

const getManageDeliveryPanelStyle = ({
  borderTopColor,
  isManageDeliveryExpanded,
}: {
  borderTopColor?: string
  isManageDeliveryExpanded: boolean
}): CSSProperties => ({
  borderTopWidth: isManageDeliveryExpanded ? '1px' : '0px',
  borderTopColor,
  maxHeight: isManageDeliveryExpanded ? '320px' : '0px',
  opacity: isManageDeliveryExpanded ? 1 : 0,
  overflow: 'hidden',
  paddingTop: isManageDeliveryExpanded ? '16px' : '0px',
  paddingBottom: isManageDeliveryExpanded ? '16px' : '0px',
  pointerEvents: isManageDeliveryExpanded ? 'auto' : 'none',
  transition:
    'max-height 240ms ease, opacity 240ms ease, padding-top 240ms ease, padding-bottom 240ms ease, border-top-width 240ms ease',
})

type ResponsiveManageDeliveryPanelProps = {
  isManageDeliveryExpanded: boolean
  orderDeliveryDetails: DashboardExperienceOrderDeliveryDetailsResponse | undefined
}

export const ResponsiveManageDeliveryPanel = ({
  isManageDeliveryExpanded,
  orderDeliveryDetails,
}: ResponsiveManageDeliveryPanelProps) => (
  <>
    <Box
      display={['block', 'block', 'none']}
      id="manage-delivery-panel"
      aria-hidden={!isManageDeliveryExpanded}
      data-testid="manage-delivery-panel"
      bg={Color.NeutralGrey_50}
      borderColor={Color.ColdGrey_100}
      borderStyle={BorderStyle.Solid}
      paddingH={4}
      style={getManageDeliveryPanelStyle({
        borderTopColor: isManageDeliveryExpanded ? '#FFFFFF' : undefined,
        isManageDeliveryExpanded,
      })}
    >
      <ManageDeliveryPanelContent orderDeliveryDetails={orderDeliveryDetails} />
    </Box>
    <Box
      display={['none', 'none', 'block']}
      aria-hidden={!isManageDeliveryExpanded}
      bg={Color.NeutralGrey_50}
      borderColor={Color.ColdGrey_100}
      borderStyle={BorderStyle.Solid}
      paddingH={4}
      style={getManageDeliveryPanelStyle({ isManageDeliveryExpanded })}
    >
      <ManageDeliveryPanelContent orderDeliveryDetails={orderDeliveryDetails} />
    </Box>
  </>
)
